import React, { useContext } from "react";
import { UserContext } from "../../utils/userContext";
import { isSuperAdmin } from "../../utils/roles";
import AccessDenied from "../ui/AccessDenied";

const withSuperAdmin = (WrappedComponent) => {
  return (props) => {
    const { user, isLoading } = useContext(UserContext);

    if (isLoading) return null;
    if (!isSuperAdmin(user)) {
      return <AccessDenied message="Access denied. Super admin only." />;
    }

    return <WrappedComponent {...props} />;
  };
};

export default withSuperAdmin;
